__turbopack_context__.v({
  "heroSentinel": "LeaderboardPage-module__bNGWLW__heroSentinel",
  "listWrap": "LeaderboardPage-module__bNGWLW__listWrap",
});
